<template>
  <div v-if="isShow && announcementList && announcementList.length" class="announcement-swiper-container ui-box">
    <div class="announcement-info">
      <el-carousel height="44px" direction="vertical" :autoplay="true">
        <el-carousel-item v-for="item in announcementList" :key="item.id">
          <div class="carousel-item-container">
            <div class="carousel-item-summary">
              {{ item.summary }}
            </div>
            <el-button type="text" @click="toAnnouncementDetails(item.id)">
              查看详情
            </el-button>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { filter, find, get } from 'lodash';
import fetch from '@/lib/fetch';

export default {
  data() {
    return {
      isShow: false,
      // 直播数据、数据概览、订单明细、优惠券、结算中心（这些模块显示对应的通知管理模块）
      showEmoduleList: ['displayBoard', 'statisticSummary', 'statisticOrder', 'coupon', 'settlement'],
      announcementList: [], // 公告列表
      routerName: '', // 当前的模块名称
      announcementEmoduleList: [
        {
          label: '结算中心',
          value: 1,
          name: 'settlement',
        },
        {
          label: '直播数据',
          value: 2,
          name: 'displayBoard',
        },
        {
          label: '数据概览',
          value: 3,
          name: 'statisticSummary',
        },
        {
          label: '订单明细',
          value: 4,
          name: 'statisticOrder',
        },
        {
          label: '优惠券',
          value: 5,
          name: 'coupon',
        },
      ],
    };
  },
  // 监听对应的事件
  watch: {
    $route(val) {
      this.processAnnouncementShow(val);
    },
  },
  mounted() {
    // 初始化展示
    this.processAnnouncementShow(this.$route);
  },
  methods: {
    // 前往公告详情页
    toAnnouncementDetails(id) {
      this.$router.push({
        name: 'announcementDetails',
        query: {
          id,
        },
      });
    },
    // 查找是否为白名单列表内
    processAnnouncementShow(route) {
      const name = get(route, 'name');
      this.routerName = name;
      this.isShow = Boolean(find(this.showEmoduleList, findItem => findItem === name));
      this.getAnnouncementList();
    },
    getAnnouncementList() {
      if (!this.isShow) return;
      this.announcementList = [];
      fetch.post('v3/announcement_center/query_bulletin_summary_list', { }).then((res) => {
        const list = get(res, 'bulletin_summary_list') || [];
        const findModule = find(this.announcementEmoduleList, item => item.name === this.routerName);
        const modueID = get(findModule, 'value');
        this.announcementList = filter(list, item => Number(item.module) === modueID);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.announcement-swiper-container {
  // padding: 0 16px;
  box-sizing: border-box;
  // margin-top: 16px;
  .announcement-info {
    background: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    color: #FAA100;
    margin-bottom:var(--ui-layout-spacing);
    .carousel-item-container {
      display: flex;
      align-items: center;
      height: 100%;
      justify-content: space-between;
      box-sizing: border-box;
      padding-right: 15px;
      .el-button {
        font-size: 12px;
      }
      .carousel-item-summary {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
}
</style>
